import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { TextInputComponent } from '../text-input/text-input.component';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss'],
  standalone: false
})
export class DateInputComponent extends TextInputComponent implements OnInit {
  @ViewChild(MatDatepicker, { static: true }) datepicker: MatDatepicker<DateTime>;

  public ngOnInit(): void {
    if (!this.control) {
      throw Error("Control was not provided");
    }
  }

  public openCalendar(): void {
    this.datepicker.open();
  }
}
